import React from 'react';
import Big from 'big.js';
import { useTranslation } from 'react-i18next';
import { helperMargin, Typography } from '@utex/ui-kit';
import { currencyToLabel } from '../../consts';
import { NumberView } from '../NumberView';

interface Props {
  title?: string;
  amount: number;
  currency: string;
  fee: number;
}

export const Commission: React.FC<Props> = ({ amount, fee, title, currency }) => {
  const { t } = useTranslation('deposit');

  const withdrawAmount = new Big(amount)
    .div(100 - fee)
    .mul(100)
    .round(2)
    .valueOf();

  return (
    <Typography.Paragraph
      size="M"
      view="hint"
      css={helperMargin({ left: { tablesktop: 15 }, bottom: { phonablet: 10 } })}
    >
      {title || t('Wallet withdraw amount')} {withdrawAmount}{' '}
      {currencyToLabel[currency] || currency}
      <br />
      {t('Payment system commission')} <NumberView>{fee}</NumberView>%
    </Typography.Paragraph>
  );
};
